export const getS3FileKey = (url: string): string => {
  try {
    return decodeURIComponent(new URL(url).pathname.replace(/^\//, ''))
  } catch {
    const parts = url.split('/')
    return decodeURIComponent(parts[parts.length - 1] ?? url)
  }
}

export const isViewableDocument = (url: string): boolean => {
  return /\.(docx?|rtf|txt|pptx?|ppsx?|xlsx?|pdf|odt|ods|odp)$/i.test(url)
}

export const isWordDocument = (fileKey: string): boolean => {
  return /\.docx?$/i.test(fileKey)
}

export const getDocumentViewerPath = (
  url: string,
  name: string,
  downloadable: boolean,
  contentId?: string
): string => {
  const params = new URLSearchParams({
    title: name,
    isEnabled: downloadable ? 'true' : 'false'
  });

  if (contentId) {
    params.set('contentId', contentId);
  }

  return `/doc/${encodeURIComponent(getS3FileKey(url))}?${params.toString()}`
}
